module.exports = __webpack_public_path__ + "static/logo-new-93302932cfd9da2488aa263fde2bfa82.png";